import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { Container, Dimmer, Loader, Grid } from 'semantic-ui-react';
import { get } from 'lodash';
import { sortByName, sortByTradeskill } from '../selectors/simpleNameSortSelector';
import ItemSummaryCard from './summary-card/ItemSummaryCard';
import ExtraInfoTabs from './tabs/ExtraInfoTabs';
import ModelViewer from '../../common/model-viewer/ModelViewer';
import Model from '../../common/model-viewer/Model';

class ItemDetailComponent extends Component {

    render() {
        const {item, quests, questRewards, ingredient, recipes, collections, vendors, isFetching} = this.props;
        const appearanceId = get(item, 'Equipment.Appearance.Id', undefined);
        const model = new Model({item: item});

        const modelViewer = appearanceId ?
                                <ModelViewer appearanceId={appearanceId} model={model} /> :
                                null;

        return (
            <Container>
                <Helmet>
                    <title>{item.Name.English}</title>
                    <meta property="og:title" content={item.Name.English} />
                    <meta property="og:url" content={`https://telaradb.com/#/items/${item.ItemKey}`} />
                    <meta property="og:image" content={`https://telaradb.com/#/images/${item.Icon}.png`} />
                    <meta property="og:site_name" content="TelaraDb.com" />
                </Helmet>
                <div>
                    <Dimmer active={isFetching}>
                        <Loader>Loading...</Loader>
                    </Dimmer>

                    <Grid relaxed stackable>
                        <Grid.Row>
                            <Grid.Column computer={5} tablet={5} mobile={16}><ItemSummaryCard item={item} /></Grid.Column>
                            <Grid.Column computer={10} tablet={10} mobile={16}>
                                {modelViewer}
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row columns={1}>
                            <ExtraInfoTabs quests={quests} questRewards={questRewards} ingredient={ingredient} recipes={recipes} collections={collections} vendors={vendors}/>
                        </Grid.Row>
                    </Grid>
                </div>
            </Container>
        )
    }
};

const mapStateToProps = state => ({
    item: state.itemState.item,
    quests: sortByName(state.itemState.item.QuestItems),
    questRewards: sortByName(state.itemState.item.QuestRewards),
    ingredient: sortByTradeskill(state.itemState.item.IngredientIn),
    recipes: sortByTradeskill(state.itemState.item.CreatedBy),
    collections: sortByName(state.itemState.item.Collections),
    vendors: state.itemState.item.SoldBy,
    isFetching: state.itemState.isFetching,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps())(ItemDetailComponent);


// WEBPACK FOOTER //
// ./src/items/detail/ItemDetailComponent.jsx